import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import SafeIcon from '../../common/SafeIcon';
import { FiLock } from 'react-icons/fi';

const Login = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    const correctPassword = import.meta.env.VITE_ADMIN_PASSWORD || 'admin';
    
    if (password === correctPassword) {
      localStorage.setItem('admin_auth', 'true');
      navigate('/admin/dashboard');
    } else {
      setError('Falsches Passwort.');
    }
  };

  return (
    <div className="max-w-md mx-auto mt-20 bg-white p-8 rounded-xl shadow-sm border border-slate-200">
      <Helmet>
        <title>Admin Login | Dividenden Investor</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="text-center mb-8">
        <div className="w-16 h-16 bg-finance-blue rounded-full flex items-center justify-center mx-auto mb-4">
          <SafeIcon icon={FiLock} className="text-white text-2xl" />
        </div>
        <h2 className="text-2xl font-bold text-finance-blue">Admin-Bereich</h2>
        <p className="text-slate-500 text-sm mt-2">Bitte Passwort eingeben, um fortzufahren.</p>
      </div>

      <form onSubmit={handleLogin} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Passwort
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-2 focus:ring-finance-green focus:border-transparent outline-none transition"
            placeholder="••••••••"
            required
          />
        </div>

        {error && <p className="text-red-500 text-sm font-medium">{error}</p>}

        <button
          type="submit"
          className="w-full bg-finance-blue hover:bg-finance-green text-white font-semibold py-2.5 rounded-md transition-colors"
        >
          Einloggen
        </button>
      </form>
    </div>
  );
};

export default Login;